<div class="auth-container">
    <div class="auth-form">
        <div class="auth-form-content">

            <!-- Logo -->
            <div>
                <img *ngIf="logoUrl" [src]="logoUrl" alt="Logo" class="sidebar-logo rounded-2xl">
            </div>

            <!-- QR Code -->
            <div class="qr-code-container">
                <qrcode [qrdata]="qrCodeUri" [width]="256" [errorCorrectionLevel]="'M'"></qrcode>
            </div>

            <!-- OTP Form -->
            <form [formGroup]="otpForm" (ngSubmit)="verifyOtp()">
                <mat-form-field class="w-full">
                    <mat-label>OTP</mat-label>
                    <input matInput formControlName="otp">
                    <mat-error *ngIf="otpForm.get('otp').hasError('required')">
                        OTP is required
                    </mat-error>
                </mat-form-field>

                <button class="fuse-mat-button-large w-full mt-6"
                    mat-flat-button
                    [color]="'primary'"
                    [ngStyle]="{'background-color': customColor, 'color': textColor}" [disabled]="otpForm.invalid">
                    Verify OTP
                </button>
            </form>
        </div>
    </div>
    <div class="auth-banner" [ngStyle]="{'background-color': backgroundColor, 'color': textColor}">
        <div [innerHTML]="introductionHtml"></div>
    </div>
</div>
